import script from "./esModalFooter.vue?vue&type=script&setup=true&lang=ts"
export * from "./esModalFooter.vue?vue&type=script&setup=true&lang=ts"

import "./esModalFooter.vue?vue&type=style&index=0&id=f3a8487e&scoped=true&lang=css"

import exportComponent from "/home/aschmuck/wk/eSklepios/medsw/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f3a8487e"]])

export default __exports__